<script>
import CandelaComponent from '@/components/CandelaComponent'

export default {
  computed: {
    flex_direction() {
      return this.orientation === 'row' ? 'flex-row' : 'flex-column'
    }
  },
  extends: CandelaComponent,
  name: 'candela-control-panel'
}
</script>
<template>
  <div :class='[`d-flex`, flex_direction]'/>
</template>
